import { getMonitoringEventsByFarm } from '../../../services/farmMapping/monitoring/monitoringEvents/getMonitoringEvents'
import { queryKeys } from '../../../hooks/data/queryKeys'
import { samplingAreasQueryOptions } from '../../../hooks/data/useSamplingAreas'
import { queryClient } from '../../../queryClient'

export async function getSamplingAreas({
  values: monitoringEventIds,
  farmId,
}: {
  values: { id: string; label: string }[]
  farmId: string
}) {
  // The request would otherwise go out without the farm filter and answer every farm's
  // strata, caching that unfiltered list under the undefined-farm key for later readers.
  if (!farmId) return []

  // Raw cached entities — never mutated here, every other reader shares these objects.
  let samplingAreas = await queryClient.fetchQuery(samplingAreasQueryOptions(farmId))

  if (monitoringEventIds && monitoringEventIds.length) {
    const monitoringEvents = await queryClient.fetchQuery({
      queryKey: queryKeys.monitoringEvents(farmId),
      queryFn: ({ signal }) => getMonitoringEventsByFarm({ farmId, signal }),
    })

    const selectedEvents = monitoringEvents.filter(event =>
      monitoringEventIds.some(id => id.id === event.id),
    )

    if (selectedEvents.length) {
      samplingAreas = samplingAreas.filter(area =>
        selectedEvents.some(event => event.samplingAreas.includes(area.id)),
      )
    }
  }

  const options = samplingAreas
    .map(area => ({
      id: area.id,
      label: area.name,
      value: area.id,
    }))
    .sort((a, b) => a.label?.localeCompare(b.label))

  return options
}
